// Fund 1 (Task-18-Review, PO-Entscheidung 2026-07-17): rohe Backend-Fehlercodes dürfen nie
// ungefiltert ins UI (bindende Constraint "keine hartcodierten/unübersetzten Strings"). Nur diese
// bekannten, stabilen Codes aus apps/api/src/routes/import.ts werden über import.errors.<code>
// übersetzt (DE + EN). Alles andere — auch teils-dynamische Parser-Meldungen wie
// "import_sheet_too_large: <Blattname> (<n> rows)" — ist absichtlich NICHT gelistet und fällt auf
// die generische, übersetzte Meldung zurück statt Rohtext ins UI zu schleusen.
//
// Gemeinsames Modul (Task 19): sowohl der Upload-/Klassifikationsschritt (upload-step.tsx) als
// auch der Mapping-Schritt (mapping-step.tsx) rufen Routen auf, die dieselben Fehlercodes werfen
// können (z. B. 'sheet_type_not_confirmed' aus der PUT-mapping-Route) — daher hierher gezogen statt
// dupliziert.
const KNOWN_IMPORT_ERROR_CODES = new Set([
  'file_missing',
  'unsupported_file_type',
  'file_too_large',
  'parse_failed',
  'import_job_create_failed',
  'project_not_found',
  'customer_not_found',
  'import_job_not_found',
  'import_sheet_not_found',
  'import_already_committed',
  // #70: eigener Code für "noch nicht 'mapped', aber auch noch nicht committet" — bisher landete
  // jeder Nicht-'mapped'-Commit-Versuch auf import_already_committed, was bei einem Job, der noch
  // nie committet wurde (z. B. hängt in 'classified'), irreführend war.
  'import_not_ready',
  'sheet_type_not_confirmed',
  // #125: Quell-ID schon vergeben bzw. in der Datei doppelt — Commit verweigert (409).
  'source_ref_exists',
  'duplicate_source_ref_in_file',
  // #125 (Q5): die gewählte „Neuimport von"-Quelle ist kein committeter Import dieses Kunden.
  'reimport_source_invalid',
  // #125: Neuimport-Commit — Entscheidungen fehlen/kaputt (400), Vorschau veraltet oder mit Fehlern,
  // Löschen eines Testfalls mit Testnachweisen (409 testcase_has_evidence wie die Einzel-Löschung,
  // #106; die ganze Übernahme ist zurückgerollt).
  'reimport_decisions_required',
  'invalid_reimport_decisions',
  'reimport_preview_stale',
  'reimport_has_errors',
  'testcase_has_evidence',
  // #73: Berechnung im Hintergrund — Vorschau noch nicht fertig, Blätter noch in Erkennung,
  // Lauf abgebrochen (Neustart des Servers) bzw. fehlgeschlagen, Entwurf fehlt, schon klassifiziert.
  'import_preview_not_ready',
  'import_classification_pending',
  'import_computation_interrupted',
  'import_computation_failed',
  // #73 (Review M2): Zustand nach dem Start leer — der Entwurf wurde inzwischen verworfen.
  'import_computation_lost',
  'import_draft_missing',
  'import_already_classified',
]);

export function translateImportError(t: (key: string) => string, raw: string): string {
  // Rohcode bleibt für die Diagnose in der Konsole, geht aber nie in den role="alert"-Text.
  console.error('[import] backend error', raw);
  return KNOWN_IMPORT_ERROR_CODES.has(raw) ? t(`import.errors.${raw}`) : t('import.errors.generic');
}
